export const CARRITO_ACTION_TYPES = {
  FETCH_CARRITO_START: "carrito/FETCH_CARRITO_START",
  FETCH_CARRITO_SUCCESS: "carrito/FETCH_CARRITO_SUCCESS",
  FETCH_CARRITO_FAILED: "carrito/FETCH_CARRITO_FAILED",
};
